var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 7.119 7.119"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.13 0H0v7.1h7.13zm-.35 6.75H.36V.35h6.42zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.38 1.8c.22 0 .4.17.4.4 0 .22-.18.4-.4.4-.23 0-.4-.18-.4-.4 0-.23.17-.4.4-.4m-.35 1.1h.7v2.24h-.7zm1.13 0h.67v.3c.1-.17.33-.35.67-.35.7 0 .83.46.83 1.06v1.24h-.7v-1.1c0-.25 0-.58-.36-.58s-.4.28-.4.57v1.1h-.7zm0 0"
  })));
};

export { SvgLinkedin as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MCIgaGVpZ2h0PSI1MCIgdmlld0JveD0iMCAwIDcuMTE4OTQ1MSA3LjExODk0NTEiPgogICAgPHBhdGggZD0iTTcuMTMgMEgwdjcuMWg3LjEzem0tLjM1IDYuNzVILjM2Vi4zNWg2LjQyem0wIDAiLz4KICAgIDxwYXRoIGQ9Ik0yLjM4IDEuOGMuMjIgMCAuNC4xNy40LjQgMCAuMjItLjE4LjQtLjQuNC0uMjMgMC0uNC0uMTgtLjQtLjQgMC0uMjMuMTctLjQuNC0uNG0tLjM1IDEuMWguN3YyLjI0aC0uN3ptMCAwTTMuMTYgMi45aC42N3YuM2MuMS0uMTcuMzMtLjM1LjY3LS4zNS43IDAgLjgzLjQ2LjgzIDEuMDZ2MS4yNGgtLjd2LTEuMWMwLS4yNSAwLS41OC0uMzYtLjU4cy0uNC4yOC0uNC41N3YxLjFoLS43em0wIDAiLz4KPC9zdmc+Cg==";